<div class="dsd-m-sm">
  <p class="dsd-t-6 dsd-fw-bold">Préautorisation</p>
  <dsd-select
    class="dsd-mb-sm"
    name="statut"
    [value]="statutPreautorisation$ | async"
    (dsdSelectChange)="changeStatut($event.detail.value)"
    no-default-option
    hide-required-labelling
  >
    <span slot="label">Statut</span>
    <span slot="options">
      <option>AUCUN</option>
      <option [value]="ACCEPTEE_TAUX_EXPIRE">{{ ACCEPTEE_TAUX_EXPIRE }}</option>
      <option [value]="ACCEPTEE_TAUX_30_JOURS">{{ ACCEPTEE_TAUX_30_JOURS }}</option>
      <option [value]="ACCEPTEE_PREAUT_30_JOURS">{{ ACCEPTEE_PREAUT_30_JOURS }}</option>
      <option *ngFor="let status of statusPreautorisationValues" [value]="status">{{ status }}</option>
    </span>
  </dsd-select>

  <dsd-radio-group class="dsd-mb-sm" name="type_emprunteur" hide-required-labelling>
    <span slot="legend">Emprunteur</span>
    <dsd-radio (dsdRadioChange)="changeTypeEmprunteur(false, true)" value="unique">Unique</dsd-radio>
    <dsd-radio (dsdRadioChange)="changeTypeEmprunteur(true, true)" value="co1">Coemprunteur 1</dsd-radio>
    <dsd-radio (dsdRadioChange)="changeTypeEmprunteur(true, false)" value="co2">Coemprunteur 2</dsd-radio>
  </dsd-radio-group>

  <dsd-select
    class="dsd-mb-sm"
    name="page"
    (dsdSelectChange)="changeCurrentStep($event.detail.value)"
    hide-required-labelling
  >
    <span slot="label">Aller à une étape</span>
    <span slot="options">
      <option *ngFor="let step of stepValues" [value]="StepEnum[step]">{{ step }}</option>
    </span>
  </dsd-select>

  <div>
    <dsd-button (dsdButtonClick)="navigatePagePreautEnCours()" variant="compact" class="dsd-mr-sm">
      Page préaut active
    </dsd-button>
    <dsd-button (dsdButtonClick)="navigatePageAnuleParCoemprunteur()" variant="compact">Page préaut annulée</dsd-button>
  </div>
</div>
